import { render, staticRenderFns } from "./StockData.vue?vue&type=template&id=2cbb8a3c&scoped=true&"
import script from "./StockData.vue?vue&type=script&lang=js&"
export * from "./StockData.vue?vue&type=script&lang=js&"
import style0 from "./StockData.vue?vue&type=style&index=0&id=2cbb8a3c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cbb8a3c",
  null
  
)

export default component.exports